import "./VulnerabilityAssessments.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Servicedetail from "./sections/Servicedetail";
import Footer from "@/reusable_sections/Footer";
export default function VulnerabilityAssessmentsPage() {
  return <div>
      <Header />
      <Hero />
      <Servicedetail />
      <Footer />
    </div>;
}